import { connect } from 'react-redux';
import {actions} from '../../../../../redux/modules/fincas';
import FincaVer from './FincaVer';

const mstp = state => {
    return {...state.fincas}
};

const mdtp = {
    ...actions
};

export default connect(mstp, mdtp)(FincaVer)
